module.exports = __webpack_public_path__ + "static/modify_memory-fbae17374fa08323ec1f897eaaa03422.jpg";